import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  ResponseDto,
  StepUpVerifyDto,
  StepUpVerifyResponseDto,
} from "@mimber/schema"
import { accountKeys, securityEventsKeys } from "../account.utils"

export const useVerifyStepUp = (
  options?: UseMutationOptions<
    ResponseDto<StepUpVerifyResponseDto>,
    Error,
    StepUpVerifyDto
  >
): UseMutationResult<
  ResponseDto<StepUpVerifyResponseDto>,
  Error,
  StepUpVerifyDto
> => {
  guardAppUsage("mimber-organization", "useVerifyStepUp")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (data: StepUpVerifyDto) => {
      const response = await server.post<ResponseDto<StepUpVerifyResponseDto>>(
        "account/mfa/step-up/verify",
        data
      )
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: accountKeys.getStepUpStatus(),
      })
      queryClient.invalidateQueries({
        queryKey: securityEventsKeys.findAll(),
      })
      options?.onSuccess?.(response, variables, onMutateResult, context)
    },
  })
}
